/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */

import { use, withMemo } from 'fierry/react';

import Navigation from 'solis/navigation';

import HexGeometry from 'solis/react/board/geometry/hex';

import Data from 'solis/react/board/data';
import SimpleData from 'solis/react/board/data/simple';
import ColonyData from 'solis/react/board/data/colony';
import BoardData from 'solis/react/board/data/board';

import Settings from 'solis/react/board/settings';

import Svg from 'solis/react/board/svg';
import Zone from 'solis/react/board/zone';

import OffsetState from 'solis/react/board/svg/offset.state';


export { Preview, Selectable, Focused, Interactive } from 'solis/react/board/settings/presets';


const Zones = withMemo(() =>
{
  const data = use(Data);
  const settings = use(Settings);

  return [...data.getZones()].map((zoneData) =>
  (
    <Zone key = {zoneData.getDisplayHex()} data = {data} zoneData = {zoneData} selected = {settings.isSelected(zoneData)} emphasized = {zoneData.isEmphasized()} groupEmphasized = {settings.isGroupEmphasis() && zoneData.isEmphasized()} dimmed = {settings.isDimming() && zoneData.isDimmed()} />
  ));
});


const Component = withMemo(({ width, height, zoom, overlay, ...props }) =>
(
  <HexGeometry.Export zoom = {zoom}>
    <OffsetState.Export>

      <Svg {...props} width = {width} height = {height}>
        <Zones />
        {overlay}
      </Svg>

    </OffsetState.Export>
  </HexGeometry.Export>
));


export const WithHexes = ({ hexes, settings, zoom = 3, ...props }) =>
{
  const data = new SimpleData({ hexes });

  return <WithData {...props} zoom = {zoom} data = {data} settings = {settings} />;
};


export const WithColony = ({ colony, settings, ...props }) =>
{
  const data = new ColonyData({ colony });

  return <WithData {...props} data = {data} settings = {settings} />;
};


export const WithBoard = ({ board, settings, ...props }) =>
{
  const data = new BoardData({ board });

  return <WithData {...props} data = {data} settings = {settings} />;
};


export const WithData = withMemo(({ data, settings, ...props }) =>
(
  <Data value = {data}>
    <Settings.Export config = {settings} navigation = {Navigation} dispatch = {Navigation.Dispatch} data = {data}>

      <Component {...props} />

    </Settings.Export>
  </Data>
));

